import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMedium } = breakpoints;
const S = {};

S.OfferBlock = {};

S.OfferBlock.Title = styled.h2`
  label: Title;

  margin-bottom: 1.2rem;
`;

S.BackgroundImage = styled.img`
  label: BackgroundImage;

  width: 100%;
  min-height: 10rem;
  object-fit: cover;
  object-position: top right;
  display: block;

  @media (${widthSmall}) {
    min-height: 12.25rem;
  }

  @media (${widthMedium}) {
    min-height: 20.62rem;
  }
`;

export default S;
